export function getAllAgreements(axiosPrivate) {
  return axiosPrivate.get('/trade-data-agreement/list-agreements')
}

export function getOptionAgreements(axiosPrivate) {
  return axiosPrivate.get('/trade-data-agreement/options')
}

export function getAgreementById(axiosPrivate, params) {
  const id = params.idAgreement
  return axiosPrivate.get(`/trade-data-agreement/${id}`)
}

export function createAgreement(axiosPrivate, formData) {
  return axiosPrivate.post('/trade-data-agreement/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function updateAgreementById(axiosPrivate, id, params) {
  return axiosPrivate.put(`/trade-data-agreement/${id}/update`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function deleteAgreementContentById(axiosPrivate, id) {
  return axiosPrivate.delete(`/trade-data-agreement/chapter/${id}`)
}

export function exportAgreementDetail(axiosPrivate, params) {
  return axiosPrivate.post(`/trade-data-agreement/export-contents`, params)
}
